<template>
  <page-view class="page-live" :is-loading="isLoading" fill-height>
    <template #header>
      <base-header
        title="Lives"
        has-intro
        :info="
          allItems.length > 1
            ? `${allItems.length} lives`
            : allItems.length === 1
            ? `${allItems.length} live`
            : false
        "
      >
        <template #actions>
          <template v-if="hasEditLivePerm">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="text-center"
                  :class="!isMobileBreakpoint ? 'd-flex' : ''"
                  v-bind="verifyPermissions(permissions) ? attrs : false"
                  v-on="verifyPermissions(permissions) ? on : false"
                >
                  <div>
                    <base-btn
                      v-if="keysAttached.length >= 1"
                      type="secondary"
                      class="mr-6"
                      :disabled="isLoading"
                      @click="openModal"
                    >
                      {{
                        $t('message.keysCount') + ` (${keysAttached.length})`
                      }}
                    </base-btn>
                    <base-btn
                      v-else
                      else="keysLength > 1"
                      type="secondary"
                      :disabled="isLoading"
                      class="mr-6"
                      @click="openModal"
                    >
                      {{ $t('message.gerateKey') }}
                    </base-btn>
                    <base-btn
                      v-if="isSubscriptionIsActive"
                      :data-intro="
                        !newLiveDialog ? $t('message.introJS.live.add') : null
                      "
                      :disabled="verifyPermissions(permissions)"
                      @click="handleAddLive"
                      large
                      :loading="loadings.addLive"
                    >
                      <v-icon color="#fff">mdi-access-point</v-icon>
                      {{ $t('message.pages.live.newLive') }}
                    </base-btn>
                    <base-btn
                      v-else
                      :data-intro="
                        !newLiveDialog ? $t('message.introJS.live.add') : null
                      "
                      :disabled="
                        verifyPermissions(permissions) ||
                        isLoading ||
                        list.keys.length === 0
                      "
                      @click="handleAddLive"
                      large
                      :loading="loadings.addLive"
                    >
                      <v-icon color="#fff">mdi-access-point</v-icon>
                      {{ $t('message.pages.live.newLive') }}
                    </base-btn>
                  </div>
                  <!--
                  <v-btn v-else large color="primary" class="px-3" @click="handleCreateLive"
                  :disabled="createLiveTitle === '' || loadings.createLive" :loading="loadings.createLive">
                  {{ $t('message.pages.live.startLive') }}
                </v-btn> -->
                </div>
                <aside>
                  <KeysModal />
                </aside>
              </template>
              <span>{{ $t('message.noPermissionToDo') }}</span>
            </v-tooltip>
          </template>
        </template>
      </base-header>
    </template>

    <template #content>
      <div
        style="max-height: 80vh"
        :data-intro="
          !newLiveDialog && !selectedItems.length
            ? $t('message.introJS.live.list')
            : null
        "
      >
        <!-- actions -->
        <v-row no-gutters v-if="allItems.length">
          <v-col
            :cols="isMobileBreakpoint ? 12 : 'auto'"
            :order="isMobileBreakpoint ? 'first' : ''"
            class="mr-2"
          >
            <SearchBar
              :list="allItems"
              :fuseOptions="fuseOptions"
              :placeholder="$t('message.pages.live.searchLive')"
            />
          </v-col>
          <v-col
            v-if="hasEditLivePerm"
            v-show="selectedItems.length"
            :cols="isMobileBreakpoint ? 12 : 'auto'"
          >
            <base-btn
              :disabled="!selectedItems.length"
              color="red"
              @click="handleRemoveLive"
            >
              {{ $t('message.remove') }}
            </base-btn>
          </v-col>
        </v-row>

        <warning-trial />

        <!-- data-table::header -->
        <v-card
          v-if="allItems.length"
          flat
          width="100%"
          height="45px"
          class="data-table__header"
        >
          <v-row no-gutters>
            <v-card
              class="d-flex align-center justify-center"
              height="45px"
              flat
              style="width: 3.2%"
            >
              <v-simple-checkbox
                v-if="hasEditLivePerm"
                :color="!checkboxIndeterminateStatus ? 'primary' : ''"
                :indeterminate="checkboxIndeterminateStatus"
                :ripple="false"
                :value="anyItemSelected"
                @input="selectAllItems"
              ></v-simple-checkbox>
            </v-card>
            <div
              style="width: 41.55%"
              class="d-flex align-center justify-start pl-3"
            >
              <v-hover v-slot="{ hover }">
                <v-row no-gutters @click="handleOrderByName">
                  <span
                    class="headerDataTable font-weight-regular mt-1"
                    style="height: 24px"
                  >
                    <b
                      >{{ $t('message.pages.videosDataTable.header.name') }}
                    </b>
                  </span>
                  <v-icon v-if="hover && !nameOrder" color="grey lighten-1"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="nameOrder === 'desc'">mdi-menu-down</v-icon>
                  <v-icon v-if="nameOrder === 'asc'">mdi-menu-up</v-icon>
                </v-row>
              </v-hover>
            </div>
            <div style="width: 13.75%" class="d-flex align-start justify-start">
              <v-card class="d-flex align-center" height="45px" flat>
                <span class="headerDataTable font-weight-regular"
                  ><b>{{
                    $t('message.pages.live.additionalResources')
                  }}</b></span
                >
              </v-card>
            </div>
            <div style="width: 13.75%" class="d-flex align-start justify-start">
              <v-card class="d-flex align-center" height="45px" flat>
                <span class="headerDataTable font-weight-regular"
                  ><b>Status</b></span
                >
              </v-card>
            </div>
            <div
              style="width: 13.75%"
              class="d-flex align-center justify-start pr-3"
            >
              <v-card class="d-flex align-center" height="45px" flat>
                <span class="headerDataTable font-weight-regular"
                  ><b>{{ $t('message.pages.newLive.start') }}</b></span
                >
              </v-card>
            </div>
            <div
              style="width: 13.75%"
              class="d-flex align-center justify-start"
            >
              <v-card class="d-flex align-center" height="45px" flat>
                <span class="headerDataTable font-weight-regular"
                  ><b>{{ $t('message.pages.live.createdAt') }}</b></span
                >
              </v-card>
            </div>
          </v-row>
        </v-card>

        <!-- data-table -->
        <vue-virtual-table
          v-if="filteredItems.length > 0"
          :class="{
            displayNone: isLoading,
            displayBlock: !isLoading,
            virtualTable: $vuetify.theme.dark,
          }"
          class="virtual-table-live pointerTable data-table__content"
          :config="tableConfig"
          :data="allItems"
          :height="tableHeight"
          :itemHeight="48"
          :minWidth="750"
          @contextmenu="show"
          @click="handleClickRow"
        >
          <template slot-scope="scope" slot="selectCommon">
            <v-row
              class="d-flex flex-row pt-2"
              justify="center"
              align="center"
              no-gutters
              v-if="hasEditLivePerm"
              @click="handleClickRow(scope.row)"
            >
              <v-simple-checkbox
                color="primary"
                :ripple="false"
                :value="checkIfSelected(scope.row)"
                @input="checkboxSelection(scope.row)"
              ></v-simple-checkbox>
            </v-row>
          </template>
          <template slot-scope="scope" slot="titleCommon">
            <v-row
              no-gutters
              class="d-flex flex-row align-center pl-1"
              @click="handleClickRow(scope.row)"
            >
              <v-btn
                icon
                v-if="scope.row.status === 'online'"
                @click="goToPainel(scope.row)"
                style="padding-top: 2px"
              >
                <v-icon class="pr-2 pl-2" color="turquisePanda"
                  >mdi-access-point</v-icon
                >
              </v-btn>
              <v-btn
                icon
                v-else-if="scope.row.status === 'offline'"
                @click="goToPainel(scope.row)"
                style="padding-top: 2px"
              >
                <v-icon class="pr-2 pl-2">mdi-access-point-off</v-icon>
              </v-btn>
              <v-btn
                icon
                v-else-if="scope.row.status === 'canceled'"
                @click="goToPainel(scope.row)"
                style="padding-top: 2px"
              >
                <v-icon color="primary" class="pr-2" style="display: contents"
                  >mdi-play-circle-outline</v-icon
                >
              </v-btn>
              <v-btn
                icon
                v-else
                @click="goToPainel(scope.row)"
                style="padding-top: 2px"
              >
                <v-icon color="primary" class="pr-2" style="display: contents"
                  >mdi-play-circle-outline</v-icon
                >
              </v-btn>
              {{ scope.row.title }}
              <v-chip-legacy
                color="#F7F7FA"
                class="ml-2 text-caption"
                style="
                  font-size: 10px;
                  color: #121010;
                  font-weight: 400;
                  height: 21px;
                "
                v-if="scope.row.old_live"
              >
                {{ $t('message.pages.newLive.oldFormat') }}
              </v-chip-legacy>
            </v-row>
          </template>
          <template slot-scope="scope" slot="resourcesCommom">
            <v-row no-gutters>
              <v-col
                cols="12"
                class="d-flex justify-start"
                @click="goToPainel(scope.row)"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-chip-legacy
                        v-if="scope.row.active_dvr"
                        color="#F7F7FA"
                        class="mr-2 rounded-fill"
                        dark
                        style="
                          font-size: 10px;
                          color: #121010;
                          font-weight: 400;
                          height: 21px;
                        "
                      >
                        DVR
                      </v-chip-legacy>
                    </span>
                  </template>
                  <span>
                    {{ $t('message.pages.live.dvrTooltip1') }}<br />
                    {{ $t('message.pages.live.dvrTooltip2') }}<br />
                    {{ $t('message.pages.live.dvrTooltip3') }}
                  </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-chip-legacy
                        v-if="scope.row.bitrate"
                        color="#F7F7FA"
                        class="mr-2 rounded-fill"
                        dark
                        style="
                          font-size: 10px;
                          color: #121010;
                          font-weight: 400;
                          height: 21px;
                        "
                      >
                        ABR
                      </v-chip-legacy>
                    </span>
                  </template>
                  <span>{{ $t('message.pages.live.bitrateTooltip') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
          <template slot-scope="scope" slot="statusCommom">
            <v-row no-gutters class="mt-2 mt-2" @click="goToPainel(scope.row)">
              <div class="d-flex justify-start">
                <p
                  v-if="
                    scope.row.scheduled_at &&
                    new Date(scope.row.scheduled_at) > new Date() &&
                    scope.row.status === 'offline'
                  "
                  class="status-button mb-0 status--scheduled rounded-pill"
                  :class="getStatus('scheduled').classColor"
                >
                  {{ getStatus('scheduled').label }}
                </p>
                <span
                  v-else-if="scope.row.status === 'finished'"
                  class="ml-2 secondaryText--text caption noIbar rounded-pill"
                >
                  <v-icon>mdi-progress-upload</v-icon>
                  {{ $t('message.converting') }}...
                </span>
                <p
                  v-else
                  class="status-button mb-0 rounded-pill"
                  :class="getStatus(scope.row.status).classColor"
                >
                  {{ getStatus(scope.row.status).label }}
                </p>
              </div>
            </v-row>
          </template>
          <template slot-scope="scope" slot="startedCommom">
            <v-row
              @click="goToPainel(scope.row)"
              v-if="scope.row.started_at"
              no-gutters
              class="ml-2 mt-2 justify-start"
            >
              {{
                new Date(scope.row.started_at)
                  .toLocaleString('pt-BR')
                  .slice(0, 3) +
                new Date(scope.row.started_at)
                  .toLocaleString('pt-BR')
                  .slice(3, 5) +
                '/' +
                new Date(scope.row.started_at)
                  .toLocaleString('pt-BR')
                  .slice(8, 10)
              }}
              {{ $t('message.pages.AbTest.at') }}
              {{
                `${getDateWithZero(
                  new Date(scope.row.started_at).getHours()
                )}:${getDateWithZero(
                  new Date(scope.row.started_at).getMinutes()
                )}`
              }}
            </v-row>
          </template>
          <template slot-scope="scope" slot="createdAtCommom">
            <v-row
              @click="goToPainel(scope.row)"
              v-if="scope.row.created_at"
              no-gutters
              class="mt-2"
              justify="start"
            >
              {{
                new Date(scope.row.created_at)
                  .toLocaleString('pt-BR')
                  .slice(0, 3) +
                new Date(scope.row.created_at)
                  .toLocaleString('pt-BR')
                  .slice(3, 5) +
                '/' +
                new Date(scope.row.created_at)
                  .toLocaleString('pt-BR')
                  .slice(8, 10)
              }}
            </v-row>
          </template>
        </vue-virtual-table>

        <!-- empty -->
        <template v-else>
          <v-container v-if="!isLoading" fill-height class="empty__container">
            <v-row
              class="d-flex flex-column"
              no-gutters
              justify="center"
              align="center"
              :data-intro="
                !newLiveDialog ? $t('message.introJS.live.listEmpty') : null
              "
            >
              <img
                v-if="$vuetify.theme.dark"
                class="ml-4"
                src="@/assets/pandaLogo.svg"
                max-width="180"
              />
              <img
                v-else
                class="ml-4"
                src="@/assets/pandaHappy.svg"
                max-width="180"
              />
              <span
                class="noFilesAddedText"
                v-html="$t('message.pages.newLive.noLivesInAccountMessage1')"
              ></span>
              <span
                class="noFilesAddedText"
                v-html="$t('message.pages.newLive.noLivesInAccountMessage2')"
              ></span>
            </v-row>
          </v-container>
        </template>

        <!-- context menu -->
        <v-menu
          v-model="showMenu"
          min-width="300px"
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
          :transition="null"
        >
          <v-list dense>
            <!-- menu item: open live v2 -->
            <v-list-item
              @click="
                $router.push({
                  name: 'NewLiveV2Edit',
                  params: {
                    id: menuItem.id,
                  },
                })
              "
            >
              <v-list-item-icon>
                <v-icon>mdi-eye-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ $t('message.pages.videosDataTable.menu.open') }}
                Live V2
              </v-list-item-title>
            </v-list-item>

            <!-- menu item: open -->
            <v-list-item @click="goToPainel(menuItem)">
              <v-list-item-icon>
                <v-icon>mdi-eye-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $t('message.pages.videosDataTable.menu.open')
              }}</v-list-item-title>
            </v-list-item>

            <!-- menu item: open new window -->
            <v-list-item @click="handleOpenNewTab">
              <v-list-item-icon>
                <v-icon>mdi-open-in-new</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $t('message.pages.videosDataTable.menu.openInNew')
              }}</v-list-item-title>
            </v-list-item>

            <v-divider class="my-1" />

            <!-- menu item: copy embed code -->
            <v-menu
              top
              offset-x
              open-on-hover
              v-if="menuItem.title && selectedItems.length < 2"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  v-bind="attrs"
                  @click="handleEmbedCopy"
                  v-on="on"
                  dense
                >
                  <v-list-item-icon>
                    <v-icon>mdi-xml</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    <v-row
                      no-gutters
                      class="d-flex flex-row align-center justify-space-between"
                    >
                      {{ $t('message.pages.videosDataTable.menu.copyEmbed') }}
                      ({{ embedTrademark }})
                      <v-icon color="grey lighten-1" class="ml-2">
                        mdi-chevron-right
                      </v-icon>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
              </template>
              <v-list dense>
                <template v-for="(option, i) in embedOptions">
                  <v-list-item
                    :key="`item-options-${i}`"
                    dense
                    @click="setEmbed(option.value, menuItem)"
                  >
                    <v-list-item-title>{{ option.text }}</v-list-item-title>
                  </v-list-item>
                  <template v-if="i === 0">
                    <v-list-item
                      :key="`item-custom-${i}`"
                      dense
                      @click="openCustomizeEmbed(menuItem)"
                    >
                      <v-list-item-title>{{
                        $t('message.customize')
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-divider :key="`divider-${i}`" class="my-1" />
                  </template>
                </template>
              </v-list>
            </v-menu>

            <!-- menu item: copy hls -->
            <template v-if="menuItem.title && selectedItems.length < 2">
              <v-list-item
                :disabled="disableVideoCopyLinks"
                @click="handleCopyHLSEmbed(menuItem)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t('message.pages.videosDataTable.menu.copyHLS')
                }}</v-list-item-title>
              </v-list-item>
              <v-divider class="my-1" v-if="hasEditLivePerm" />
            </template>

            <!-- menu item: remove -->
            <v-list-item
              v-if="hasEditLivePerm"
              @click="handleRemoveLive(menuItem)"
              v-ripple="{ class: 'error--text' }"
            >
              <v-list-item-icon>
                <v-icon color="#f44336">mdi-delete</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                <span class="error--text">
                  {{ $t('message.remove') }}
                </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- dialogs -->
        <v-dialog :key="modalKey" v-model="newLiveDialog" max-width="1100">
          <!-- live -->
          <v-scroll-x-transition mode="out-in" hide-on-leave>
            <v-card class="px-2" v-if="createLivePage">
              <!-- title -->
              <v-card-title class="text-h5 createLive">
                <v-icon class="pr-2 createLive-icon" large
                  >mdi-access-point</v-icon
                >

                <span class="mr-2 createLive-title">{{
                  $t('message.pages.live.createLive')
                }}</span>
                <BaseIntroReset v-bind="{ click: refreshIntro }" />
                <v-spacer />
                <v-btn class="mr-n3" icon @click="newLiveDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <!-- content -->
              <v-row class="px-6 mt-2" style="min-height: 306px">
                <v-col cols="6 pr-8">
                  <span
                    :data-intro="
                      newLiveDialog
                        ? $t('message.introJS.live.newLiveDialog.title')
                        : null
                    "
                  >
                    <span class="modalItem-title">
                      {{ $t('message.pages.live.liveTitle') }}
                    </span>
                    <v-text-field
                      class="custom-outlined"
                      v-model="createLiveTitle"
                      :rules="[titleRules.counter]"
                      autofocus
                      hide-details
                    />
                  </span>
                  <v-radio-group
                    v-model="createLiveSelect.selected"
                    class="my-4"
                    row
                    hide-details
                    :data-intro="
                      newLiveDialog
                        ? $t('message.introJS.live.newLiveDialog.schedule')
                        : null
                    "
                  >
                    <v-radio
                      v-for="item in createLiveSelect.items"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    />
                  </v-radio-group>

                  <v-card-text
                    class="px-0 mt-n4"
                    v-if="createLiveSelect.selected === 'schedule'"
                  >
                    {{ $t('message.pages.live.scheduleNewLiveSubtitle') }}
                  </v-card-text>
                  <v-col
                    cols="12"
                    v-if="createLiveSelect.selected === 'schedule'"
                    class="pb-0"
                  >
                    <v-row justify="center" class="mt-n7">
                      <v-col class="datepicker-container px-0 pr-1">
                        <v-select-legacy
                          style="height: 40px"
                          ref="dateSelect"
                          :placeholder="$t('message.pages.live.pickDate')"
                          :items="scheduleDate === null ? [''] : [scheduleDate]"
                          no-data-text=""
                          v-model="scheduleDate"
                          item-disabled
                          @click="handleClickSelect"
                          class="dateSelect custom-outlined"
                        />
                        <v-card
                          v-if="datePickerShow"
                          class="datepicker-item"
                          v-click-outside="handleClickDatePickerOutside"
                        >
                          <v-date-picker
                            v-model="scheduleDate"
                            header-color="primary"
                            @change="filterHours"
                            color="primary"
                            :locale="$t('message.pages.live.locale')"
                            no-title
                            :allowed-dates="getAllowedDate"
                          />
                        </v-card>
                      </v-col>
                      <v-col class="px-0 pl-1">
                        <v-select-legacy
                          class="timeSelect"
                          :items="hoursMinutes"
                          :placeholder="$t('message.pages.live.pickTime')"
                          v-model="selectedHour"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pa-0 mt-5">
                    <span class="d-block modalItem-title mb-1">
                      {{ $t('message.pages.live.key') }}
                    </span>
                  </v-col>

                  <v-select-legacy
                    class="custom-outlined"
                    :key="selectorKey"
                    v-model="form.selected"
                    :items="list.keys"
                    no-data-text=""
                    hide-details
                    item-value="id"
                    :item-text="(item) => item.title"
                    persistent
                    @change="handleSelectChange"
                  />

                  <!-- <template>
                  <LiveKeys @selected-live-stream-key="handleSelectedStreamKey" @close-modal-event="handleCloseEvent"
                    @return-modal-event="handleReturnEvent" />
                </template> -->
                </v-col>

                <v-divider vertical />

                <v-col cols="6 pl-8" style="padding-top: 4px">
                  <span
                    :data-intro="
                      newLiveDialog
                        ? $t('message.introJS.live.newLiveDialog.qualities')
                        : null
                    "
                  >
                    <!-- qualities: title -->
                    <v-container class="d-flex align-center pa-0">
                      <span class="modalItem-title">{{
                        $t('message.pages.live.availableQualities')
                      }}</span>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon
                              style="color: var(--v-neutral-lighten1)"
                              size="18"
                            >
                              mdi-help-circle
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-container
                          class="text-body-2 pa-0"
                          style="max-width: 250px"
                          >{{
                            $t('message.pages.live.qualitiesDescription')
                          }}</v-container
                        >
                      </v-tooltip>
                    </v-container>

                    <!-- qualities: items -->
                    <v-row no-gutters>
                      <v-col
                        v-for="(key, index) in Object.keys(prices).sort()"
                        :key="index"
                        cols="12"
                        class="d-flex align-end cursor-pointer pt-2"
                      >
                        <v-checkbox
                          v-model="avalibleBitrates"
                          :label="key"
                          :value="key"
                          class="pa-0 ma-0"
                          color="primary"
                          hide-details
                          dense
                        />
                        <span
                          class="text-caption text--secondary pa-0 ma-0 pl-1"
                          style="padding-bottom: 1px !important"
                        >
                          <span class="spanDescription" v-if="!isPlanGold">
                            (+ {{ prices[key] }}/min)
                          </span>
                          <span class="spanDescription" v-if="key === '720p'"
                            >({{
                              $t('message.pages.live.1080pSubtitle')
                            }})</span
                          >
                        </span>
                      </v-col>
                    </v-row>

                    <!-- qualities: default item (mandatory) -->
                    <v-row class="pt-2 d-flex align-end" no-gutters>
                      <v-checkbox
                        v-model="defaultBitrate"
                        label="Original"
                        value="Original"
                        dense
                        readonly
                        class="pa-0 ma-0"
                        color="primary"
                        hide-details
                      />
                      <span
                        class="pa-0 ma-0 pl-1 spanDescription"
                        style="padding-bottom: 1px !important"
                      >
                        ({{ $t('message.pages.live.originalSubtitle') }})
                      </span>
                    </v-row>
                  </span>

                  <!-- Latency options -->
                  <v-row
                    class="pl-3 mt-4"
                    align="center"
                    :data-intro="
                      newLiveDialog
                        ? $t('message.introJS.live.newLiveDialog.dvr')
                        : null
                    "
                  >
                    <v-col cols="12" class="pa-0 d-flex align-center">
                      <span class="d-block modalItem-title">
                        {{ $t('message.pages.live.latency') }}
                      </span>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon
                              style="color: var(--v-neutral-lighten1)"
                              size="18"
                            >
                              mdi-help-circle
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-container
                          class="text-body-2 pa-0"
                          style="max-width: 250px"
                          v-html="$t('message.pages.live.latencyDescription')"
                        ></v-container>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-radio-group
                      v-model="latencySelect.selected"
                      hide-details
                    >
                      <v-radio
                        v-for="item in latencySelect.items"
                        :key="item.value"
                        :value="item.value"
                        :disabled="item.value === 'low' && !isPlanGold"
                      >
                        <template #label>
                          <span v-if="item.value === 'low'">
                            {{ item.text }}
                            <span class="gold-only-label mr-1">{{
                              $t('message.pages.live.onlyGold')
                            }}</span>
                          </span>
                          <span v-else>
                            {{ item.text }}
                          </span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-row>

                  <!-- DVR -->
                  <v-row
                    class="pl-3 my-4"
                    align="center"
                    :data-intro="
                      newLiveDialog
                        ? $t('message.introJS.live.newLiveDialog.dvr')
                        : null
                    "
                  >
                    <v-col cols="12" class="pa-0 d-flex align-baseline">
                      <span class="d-block modalItem-title pb-1">DVR</span>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="ml-2"
                            style="margin-top: 2px"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon
                              style="color: var(--v-neutral-lighten1)"
                              size="18"
                            >
                              mdi-help-circle
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-container
                          class="text-body-2 pa-0"
                          style="max-width: 250px"
                          >{{
                            $t('message.pages.live.DVRDescription')
                          }}</v-container
                        >
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" class="pa-0">
                      <v-switch
                        v-model="activeDvr"
                        :label="
                          activeDvr
                            ? $t('message.pages.live.active')
                            : $t('message.pages.live.disabled')
                        "
                        class="ma-0 pa-0"
                        dense
                        hide-details
                      />
                    </v-col>
                  </v-row>

                  <v-row
                    no-gutters
                    class="mt-4"
                    :data-intro="
                      newLiveDialog
                        ? $t('message.introJS.live.newLiveDialog.folder')
                        : null
                    "
                  >
                    <v-col cols="12">
                      <span class="d-block modalItem-title pb-1">
                        {{ $t('message.pages.live.destinationFolder') }}:
                      </span>
                    </v-col>
                    <v-col cols="12" v-if="folder.folder_id">
                      <v-icon color="primary" style="margin-bottom: 4px">
                        mdi-folder
                      </v-icon>
                      <a
                        @click="
                          ;(choiceFolder = true), (createLivePage = false)
                        "
                        style="word-break: break-all; margin-left: -2px"
                      >
                        {{ getFolderPath(folder) }}
                      </a>
                    </v-col>
                    <v-col cols="12" v-else>
                      <v-icon color="primary" style="margin-bottom: 4px">
                        mdi-folder
                      </v-icon>
                      <a
                        @click="
                          ;(choiceFolder = true), (createLivePage = false)
                        "
                        style="margin-left: -2px"
                      >
                        /
                      </a>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- error -->
              <v-row v-if="showNoticeError">
                <v-col
                  class="d-flex justify-end pa-0"
                  style="visibility: visible"
                >
                  <span style="color: var(--danger-color); margin-right: 39px"
                    >{{ showNoticeError }}
                  </span>
                </v-col>
              </v-row>

              <!-- actions -->
              <v-card-actions
                style="margin-right: 0"
                class="px-6 py-5 d-flex justify-space-between"
              >
                <v-container
                  style="margin-right: 0"
                  class="pa-0 d-flex justify-end align-center"
                >
                  <v-btn
                    text
                    @click="newLiveDialog = false"
                    color="primary"
                    class="mr-2"
                    large
                  >
                    {{ $t('message.pages.live.cancel') }}
                  </v-btn>
                  <v-btn
                    v-if="createLiveSelect.selected === 'schedule'"
                    :disabled="
                      selectedDateTime === null ||
                      createLiveTitle === '' ||
                      loadings.createLive
                    "
                    :loading="loadings.createLive"
                    large
                    color="primary"
                    class="px-3"
                    @click="handleCreateLive"
                  >
                    {{ $t('message.pages.live.schedule') }}
                  </v-btn>
                  <v-btn
                    v-else
                    large
                    color="primary"
                    class="px-3"
                    @click="handleCreateLive"
                    :disabled="createLiveTitle === '' || loadings.createLive"
                    :loading="loadings.createLive"
                  >
                    {{ $t('message.pages.live.startLive') }}
                  </v-btn>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-scroll-x-transition>

          <!-- folder -->
          <v-dialog
            v-model="choiceFolder"
            scrollable
            persistent
            max-width="1100"
            transition="slide-x-transition"
          >
            <v-card>
              <!-- title -->
              <v-toolbar elevation="0">
                <v-toolbar-title class="text-subtitle">
                  <v-btn
                    color="primary"
                    icon
                    @click=";(createLivePage = true), (choiceFolder = false)"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                  <span style="font-size: 17px">{{
                    $t('message.pages.live.chooseFolder')
                  }}</span>
                </v-toolbar-title>
              </v-toolbar>

              <!-- START -->

              <!-- breadcrumb -->
              <v-toolbar elevation="0" class="mx-5">
                <template v-if="!isNamesTooBig">
                  <v-menu offset-y max-width="250">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" icon v-bind="attrs" v-on="on">
                        <v-icon class="elevation-0" color="primary"
                          >mdi-package-down</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in reducedBreadcrumbArray"
                        :key="index"
                        @click="handleBackTo(item)"
                        dense
                      >
                        <v-list-item-title
                          :title="item.id ? item.name : 'Panda'"
                        >
                          <span class="subtitle-2">
                            <v-icon class="mr-2 pb-1" color="primary">
                              {{ item.id ? 'mdi-folder-outline' : 'mdi-home' }}
                            </v-icon>
                            {{ item.id ? item.name : 'Panda' }}
                          </span>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-icon>mdi-chevron-right</v-icon>

                  <button
                    v-if="!selectedFolder"
                    type="button"
                    class="primary--text"
                    @click="handleBackTo(lastBreadcrumbItem)"
                  >
                    <span class="breadcrumbTexts primary--text">
                      {{
                        lastBreadcrumbItem.id
                          ? lastBreadcrumbItem.name
                          : 'Panda'
                      }}
                    </span>
                  </button>

                  <button v-else type="button" class="primary--text">
                    <span class="breadcrumbTexts primary--text">
                      {{ selectedFolder.name }}
                    </span>
                  </button>
                </template>

                <template v-else>
                  <small v-for="(item, i) in breadcrumbArray" :key="i">
                    <button
                      type="button"
                      class="primary--text"
                      @click="handleBackTo(item)"
                    >
                      <span class="breadcrumbTexts primary--text">
                        {{ item.id ? item.name : 'Panda' }}
                        <v-icon v-if="i < breadcrumbArray.length - 1"
                          >mdi-chevron-right</v-icon
                        >
                      </span>
                    </button>
                  </small>

                  <small>
                    <v-icon v-if="!!selectedFolder">mdi-chevron-right</v-icon>
                    <button
                      v-if="!!selectedFolder"
                      type="button"
                      class="primary--text"
                    >
                      <span class="breadcrumbTexts primary--text">
                        {{ selectedFolder.name }}
                      </span>
                    </button>
                  </small>
                </template>
              </v-toolbar>

              <!-- list -->
              <v-card-text style="height: 352px">
                <v-list v-if="toBeSelectedFolders.length" dense>
                  <v-list-item-group v-model="selectedFolder">
                    <v-list-item
                      v-for="folder in toBeSelectedFolders"
                      :key="folder.id"
                      :value="folder"
                      @click="handleRowClick(folder)"
                    >
                      <v-list-item-icon>
                        <v-icon v-text="'mdi-folder-outline'"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="folder.name"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        v-if="checkIfHasChildren(folder)"
                        class="my-0 py-0"
                      >
                        <v-icon color="black">mdi-arrow-right</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-row v-else no-gutters align="center" justify="center">
                  <span class="mt-8">{{ $t('message.noFoldersFound') }}</span>
                </v-row>
              </v-card-text>

              <!-- END -->

              <!-- actions -->
              <v-card-actions
                class="px-8 py-4"
                style="justify-content: flex-end"
              >
                <v-menu
                  v-model="newFolderMenu"
                  :close-on-content-click="false"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <button
                      v-bind="attrs"
                      v-on="on"
                      type="button"
                      class="primary--text"
                    >
                      <span class="breadcrumbTexts primary--text">
                        {{ $t('message.newFolder') }}
                      </span>
                    </button>
                  </template>

                  <v-card width="300">
                    <v-row no-gutters class="mx-4">
                      <v-col cols="12" class="mt-2">
                        <v-icon color="primary">mdi-folder-plus</v-icon>
                        <span class="ml-2">{{ $t('message.newFolder') }}</span>
                      </v-col>
                      <v-col cols="12" class="mt-3">
                        <v-form
                          ref="form"
                          v-model="valid"
                          lazy-validation
                          v-on:submit.prevent
                        >
                          <v-text-field
                            v-model="newFolder.name"
                            autofocus
                            dense
                            :placeholder="$t('message.name')"
                            :rules="[
                              rules.required,
                              rules.maxLength,
                              rules.minLength,
                            ]"
                            required
                            counter="50"
                            color="primary"
                            outlined
                            @keyup.enter="handleNewFolder"
                          ></v-text-field>
                        </v-form>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        text
                        :disabled="fetchingNewFolder"
                        @click="newFolderMenu = false"
                      >
                        {{ $t('message.cancel') }}
                      </v-btn>
                      <v-btn
                        small
                        color="primary"
                        text
                        :loading="fetchingNewFolder"
                        :disabled="
                          fetchingNewFolder ||
                          !valid ||
                          newFolder.name.length < 3
                        "
                        @click="handleNewFolder"
                      >
                        {{ $t('message.create') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
                <v-spacer></v-spacer>
                <v-btn
                  class="px-6"
                  text
                  :disabled="isLoading"
                  @click="
                    ;(folder.folder_id = null),
                      (choiceFolder = false),
                      (createLivePage = true)
                  "
                >
                  {{ $t('message.pages.live.goBack') }}
                </v-btn>
                <v-btn color="primary" @click="handleSelectFolder()">
                  <span class="px-5">{{
                    $t('message.pages.live.confirm')
                  }}</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-dialog>

        <modal-insufficient-live-slots />

        <v-dialog v-model="showMenuEmbed" width="600px">
          <embed-video
            v-if="mustShowEmbedModal"
            :videoId="videoId"
            :showMenuEmbed="showMenuEmbed"
            :showMenuPosition="menuPosition"
            :startTime="startTime"
            :timeVideo="timeVideo"
            :embedSelectedProp="embedSelected"
            :fetching="fetching"
            :livePlayer="livePlayer"
            :liveInfo="liveInfo"
            :video="video"
            @start-time="startTime = $event"
            @showEmbed="(val) => (showMenuEmbed = val)"
          />
        </v-dialog>
      </div>
    </template>
  </page-view>
</template>

<script>
// external imports
import _ from 'lodash'
import { isAfter, addDays, isBefore, subDays, format } from 'date-fns'
import VueVirtualTable from 'vue-virtual-table'
import { mapMutations, mapActions, mapState } from 'vuex'

// internal imports
import liveService from '@/services/liveServiceV2'
import i18n from '@/translations/lang'
import {
  PANDA_STATUS_PAGE_BR,
  PANDA_STATUS_PAGE,
  PRICE_ID_GOLD,
} from '@/config/envs'
import Storage from '@/utils/Storage'
import introMixin from '@/utils/intro.mixin.js'
import embedCode from '@/utils/embedCode.mixin.js'
import { embedOptions as platformsOfEmbed } from '@/utils/embedOptions.js'
import embedOptionOrientations from '@/utils/embedOptionOrientations.js'
import livesListMixin from '@/utils/livesListV2.mixin.js'

// API
import foldersApi from '@/services/foldersApi'
import referApi from '@/services/referApi.js'
import planApi from '@/services/planApi'
import liveStreamKeyApi from '@/services/liveStreamKeyApi'

// Components
import ModalInsufficientLiveSlots from '@/components/ModalInsufficientLiveSlots.vue'
import EmbedVideo from '@/components/EmbedVideo.vue'
import PageView from '@/layout/PageView.vue'
import SearchBar from '@/components/SearchBar.vue'
import WarningTrial from './WarningTrial.vue'

// import LiveKeys from './Settings/LiveKeys.vue'

export default {
  name: 'Live',
  components: {
    EmbedVideo,
    // LiveKeys,
    VueVirtualTable,
    ModalInsufficientLiveSlots,
    PageView,
    KeysModal: () => import('./Keys/KeysModal.vue'),
    BaseHeader: () => import('@/components/BaseHeader.vue'),
    BaseBtn: () => import('@/components/BaseBtn.vue'),
    SearchBar,
    WarningTrial,
  },
  mixins: [embedCode, introMixin, livesListMixin],
  data: () => ({
    fuseOptions: {
      keys: ['title', 'name'],
      includeScore: true,
      threshold: 0.4,
    },
    titleRules: {
      counter: (value) =>
        value.length >= 3 || i18n.t('message.pages.live.titleLimit'),
    },
    form: {
      title: '',
      selected: null,
      showKeyIndex: null,
    },
    list: {
      keys: [],
    },
    prices: {},
    selectorKey: 1,
    modalKey: 0,
    isDisabled: false,
    defaultItem: '',
    isSelected: false,
    selectedKey: null,
    showKey: false,
    showNoticeError: null,
    choiceFolder: false,
    createLivePage: true,
    selectedFolder: null,
    lastFolder: {
      name: '',
      id: null,
      parent_folder_id: null,
    },
    movedItems: [],
    breadcrumbArray: [{ name: '', id: null, parent_folder_id: null }],
    folder: {
      folder_id: null,
      folder_name: '',
    },
    newFolderMenu: false,
    newFolder: {
      name: '',
    },
    valid: false,
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 50) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
    fetchingNewFolder: false,
    showMenu: false,
    x: 0,
    y: 0,
    menuItem: {},
    avalibleBitrates: [],
    qualitiesToMakeAvailable: ['240p', '360p', '480p', '720p'],
    defaultBitrate: 'Original',
    allItems: [],
    newLiveDialog: false,
    filterText: '',
    isModalOpen: false,
    isLoading: true,
    isFetchingLives: true,
    tableHeight: window.innerHeight - 120,
    videoIdsGetStatus: {},
    item: '',
    nameOrder: false,
    scheduleDate: null,
    datePickerShow: false,
    createLiveSelect: {
      items: [
        {
          text: i18n.t('message.pages.live.schedule'),
          value: 'schedule',
        },
        {
          text: i18n.t('message.pages.live.startLive'),
          value: 'startLive',
        },
      ],
      selected: 'schedule',
    },
    latencySelect: {
      items: [
        {
          text: i18n.t('message.pages.live.low'),
          value: 'low',
        },
        {
          text: i18n.t('message.pages.live.medium'),
          value: 'default',
        },
        {
          text: i18n.t('message.pages.live.high'),
          value: 'high',
        },
      ],
      selected: 'default',
    },
    errors: {
      createLive: false,
    },
    loadings: {
      addLive: false,
      createLive: false,
      fetchData: false,
    },
    createLiveTitle: '',
    hoursMinutes: [],
    allHoursMinutes: [],
    selectedHour: null,
    activeDvr: true,
    userPullzoneName: '',
    status: {
      offline: 'OFFLINE',
      online: 'ONLINE',
      finished: i18n.t('message.pages.live.finished'),
      finished_imported: i18n.t('message.pages.live.finished_imported'),
    },
    tableConfig: [
      {
        prop: '_action',
        name: 'action',
        width: 20,
        actionName: 'selectCommon',
        alignItems: 'start',
      },
      {
        prop: '_action',
        name: i18n.t('message.pages.live.title'),
        actionName: 'titleCommon',
        width: 240,
        alignItems: 'start',
      },
      {
        prop: '_action',
        name: i18n.t('message.pages.live.additionalResources'),
        width: 80,
        actionName: 'resourcesCommom',
        alignItems: 'start',
      },
      {
        prop: '_action',
        actionName: 'statusCommom',
        width: 80,
        name: 'Status',
        sortable: true,
        alignItems: 'start',
      },
      {
        prop: '_action',
        actionName: 'startedCommom',
        width: 80,
        name: 'Started',
        sortable: true,
        alignItems: 'start',
      },
      {
        prop: '_action',
        actionName: 'createdAtCommom',
        width: 80,
        name: i18n.t('message.pages.live.createdAt'),
        sortable: true,
        alignItems: 'start',
      },
    ],
    totalSlotLivePlan: 0,
    addonSlotLive: 0,
    selectedItems: [],
    embedTrademark:
      Storage.getItem('embedType') ??
      i18n.t('message.pages.videoEditModal.embedConfiguration.default'),
    hlsEmbed: false,
    codeEmbed: false,
    srcEmbed: false,
    externalIdEmbed: false,
    embedCode: {
      useMenuItem: true,
      fromLive: true,
    },
    embedSelected: '',
    embedOptionOrientations,
    fetching: true,
    radioActive: 0,
    videoCustomSize: false,
    embedVideo: {
      width: 720,
      height: 360,
      startTimeCheckbox: false,
      startTime: '',
    },
    showMenuEmbed: false,
    mustShowEmbedModal: false,
    videoId: '',
    video: {},
    menuPosition: {
      x: 1920,
      y: 72,
    },
    startTime: '00:00:00',
    timeVideo: 0,
    stream_key_id: null,
    disableVideoCopyLinks: false,
    cloneLiveTitle: null,
    currency: '',
    currencyLocale: '',
    keysAttached: [],
    statusLabels: {
      online: {
        label: 'Online',
        classColor: 'inprogress--status-button',
      },
      offline: {
        label: 'Offline',
        classColor: 'draft--status-button',
      },
      canceled: {
        label: i18n.t('message.pages.live.canceled'),
        classColor: 'live-draft--status-button',
      },
      scheduled: {
        label: i18n.t('message.pages.newLive.scheduled'),
        classColor: 'live-draft--status-button',
      },
      finished: {
        label: i18n.t('message.converting'),
        classColor: 'live-finished--status-button',
      },
      finished_imported: {
        label: i18n.t('message.pages.live.finished_imported'),
        classColor: 'completed--status-button',
      },
    },
  }),
  async created() {
    await this.loadData()
    this.selectedKey = this.form.selected

    this.$root.$emit('changeNavItem', 3)
    let pullzoneValue = Storage.getItem(
      `pullzone-${this.$store.state.user.userInfo.sub}`
    )
    if (pullzoneValue) {
      this.userPullzoneName = pullzoneValue
    } else {
      this.getUserPullzoneName()
    }
    this.readUserFolders()
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
  },
  computed: {
    ...mapState('user', {
      userPlanInfo: 'userPlanInfo',
      folders: 'mainFolders',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    aside() {
      return [
        {
          title: 'Settings',
          icon: 'mdi-cog',
          component: () => import('./Settings/index.vue'),
          props: this.$data,
        },
      ]
    },
    filteredKeys() {
      return this.list.keys.filter((item) => !item.is_attached)
    },
    hasEditLivePerm() {
      return this.$store.state.user.userPermissions.includes('put-live')
    },
    permissions() {
      if (this.userPlanInfo?.subscription_metadata?.blocked_permissions) {
        try {
          const data = JSON.parse(
            this.userPlanInfo.subscription_metadata.blocked_permissions
          )
          if (Array.isArray(data)) return data
        } catch (err) {
          console.error(err)
        }
      }
      return []
    },
    isSubscriptionIsActive() {
      if (this.userPlanInfo?.subscription?.status) {
        if (this.userPlanInfo?.subscription.status === 'active') {
          return true
        }
      }
      return false
    },
    subscriptionIsTrial() {
      if (this.userPlanInfo?.subscription?.status) {
        if (this.userPlanInfo?.subscription.status === 'trialing') {
          return true
        }
      }
      return false
    },
    locale() {
      return this.$i18next.resolvedLanguage
    },
    localeString() {
      return this.locale === 'pt' ? 'pt-BR' : 'en-US'
    },
    checkboxIndeterminateStatus() {
      return (
        this.selectedItems.length > 0 &&
        this.selectedItems.length < this.allItems.length
      )
    },
    anyItemSelected() {
      return this.selectedItems.length > 0
    },
    toBeSelectedFolders() {
      let selectedFolders = this.folders.filter((folder) => {
        return folder.parent_folder_id === this.lastFolder.id
      })
      let itemsThatAreFolders = this.movedItems.filter((movedItem) => {
        return movedItem.name
      })
      for (let folderItem of itemsThatAreFolders) {
        let foundItem = selectedFolders.find((item) => {
          return item.id === folderItem.id
        })
        if (foundItem) {
          let filtered = selectedFolders.filter(
            (item) => item.id !== folderItem.id
          )
          selectedFolders = [...filtered]
        }
      }
      return selectedFolders
    },
    filteredItems() {
      return this.allItems.filter((item) => {
        return (
          (item.title &&
            item.title.toUpperCase().includes(this.filterText.toUpperCase())) ||
          (item.title &&
            item.title.toUpperCase().includes(this.filterText.toUpperCase()))
        )
      })
    },
    selectedDateTime() {
      if (this.selectedHour === null || this.scheduleDate === null) {
        return null
      }
      const [hour, minute] = this.selectedHour.split(':')
      const timestamp = Date.parse(`${this.scheduleDate} 00:00`)
      let date = new Date(timestamp)
      date.setHours(parseInt(hour, 10))
      date.setMinutes(parseInt(minute, 10))
      return date
    },
    aspectRatio() {
      const { video_width, video_height } = this.menuItem
      let ratio = video_height / video_width

      if (Number.isNaN(ratio)) {
        ratio = 9 / 16
      }

      return `${ratio * 100}%`
    },
    isLandscapeOrientation() {
      return parseFloat(this.aspectRatio) < 100
    },
    livePlayer() {
      return this.menuItem?.live_player || null
    },
    liveInfo() {
      return this.menuItem || null
    },
    embedOptions() {
      const [general] = platformsOfEmbed.filter(
        ({ value }) => value === 'general'
      )
      const rest = platformsOfEmbed.filter(({ value }) => value !== 'general')
      const sorted = rest.sort((a, b) => a.value.localeCompare(b.value))

      return [general, ...sorted]
    },
    isPlanGold() {
      return _.isEqual(PRICE_ID_GOLD, this.userPlanInfo.subscription?.price_id)
    },
  },
  async mounted() {
    this.isLoading = true
    this.setCurrencyConfig()
    this.loadKeysAttached()

    this.avalibleBitrates = Storage.getItem('liveBitrates') ?? []
    await this.setQualitiesPrices()

    const lives_from_cache = Storage.getItem('lives')
    if (lives_from_cache) {
      this.allItems = lives_from_cache
      this.isLoading = false
    }
    await this.fetchData()

    this.selectedKey = this.form.selected
    this.stream_key_id = this.selectedKey
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 10) {
        let hour = i < 10 ? '0' + i : i
        let minute = j < 10 ? '0' + j : j
        this.allHoursMinutes.push(`${hour}:${minute}`)
      }
    }
    window.addEventListener('resize', this.resizeTimeout)
    this.$root.$on('removeLivePage', async (videos) => {
      let myArray = this.allItems.filter(function (obj) {
        return !videos.some((video) => obj.id === video.id)
      })
      this.allItems = myArray
      Storage.setItem('lives', this.allItems)
      this.selectedItems = []
    })
    this.setEmbed(
      Storage.getItem('embedType') ??
        i18n.t('message.pages.videoEditModal.embedConfiguration.default')
    )
    this.intro_key = 'live'
    if (!this.allItems.length) this.setIntroJS({ key: 'live' })
    this.isLoading = false
    if (!this.list.keys.length) await this.loadKeysData()
  },
  watch: {
    avalibleBitrates() {
      Storage.setItem('liveBitrates', this.avalibleBitrates)
    },
    'list.keys': {
      handler(newKeys) {
        if (
          this.selectedKey &&
          !newKeys.some((key) => key.id === this.selectedKey.id)
        ) {
          this.selectedKey = null
        }
      },
      deep: true,
    },
    newLiveDialog(state) {
      setTimeout(() => {
        this.createLiveTitle = `Live ${format(new Date(), 'yyyy-MM-dd')}`
        this.cloneLiveTitle = this.createLiveTitle
        this.datePickerShow = false
        this.createLiveSelect.selected = 'schedule'
        this.scheduleDate = null
        this.selectedHour = null

        if (state === true) {
          this.setIntroJS({
            key: 'live-new-dialog',
            delay: 350,
          })
        }
      }, 200)

      if (state === false) this.intro_key = 'live'
    },
    scheduleDate() {
      if (this.createLiveTitle === this.cloneLiveTitle) {
        this.createLiveTitle = `Live ${this.scheduleDate}`
        this.cloneLiveTitle = this.createLiveTitle
      }
      this.filterHours()
    },
    nameOrder: function () {
      this.orderByName()
    },
    newFolderMenu: function () {
      this.newFolder.name = ''
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
    },
    showMenu: function () {
      this.$root.$emit('changeEmbed')
      let embedStored = Storage.getItem('embedType')
        ? Storage.getItem('embedType')
        : i18n.t('message.pages.videoEditModal.embedConfiguration.default')

      if (Storage.getItem('embedType')) {
        let embedOptionTrademark = this.embedOptions.map((val) => val.value)
        this.embedTrademark =
          this.embedOptions[embedOptionTrademark.indexOf(embedStored)].text
      } else {
        this.embedTrademark = embedStored
      }
    },
    'selectedItems.length': {
      handler(value) {
        if (!value) return

        this.setIntroJS({
          key: 'live-selected',
          delay: 350,
        })
      },
      deep: true,
      immediate: true,
    },
    '$vuetify.theme.dark'() {
    this.$nextTick(() => {
      const tableEl = this.$refs.virtualTable?.$el
      if (!tableEl) return
      // Força o navegador a recalcular o estilo
      tableEl.style.display = 'none'
      tableEl.offsetHeight
      tableEl.style.display = ''
    })
  }
  },
  beforeDestroy() {
    this.$root.$off('removeLivePage')
    window.removeEventListener('resize', this.resizeTimeout)
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_ROUTED_VIDEO',
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_MAIN_FOLDERS',
      'UPDATE_DELETED_FOLDERS',
      'UPDATE_ONLY_CUSTOMIZING',
      'UPDATE_ALL_FOLDERS',
    ]),
    ...mapActions('user', ['editFolder', 'addFolder']),

    resizeTimeout() {
      clearTimeout(this.resizeWindowTimeout)
      this.resizeWindowTimeout = setTimeout(() => {
        this.tableHeight = window.innerHeight - 150
      }, 300)
    },
    handleSelectChange(selectedKey) {
      this.selectedKey = this.form.selected
      this.stream_key_id = selectedKey

      return this.selectedKey
    },

    async loadData() {
      try {
        const { data } = await liveStreamKeyApi.getAllLiveStreamKey()
        this.list.keys = []
        for await (const item of data) {
          this.list.keys.push(item)
        }
      } catch (err) {
        console.log(err)
      }
    },
    verifyPermissions(permissions) {
      return (
        permissions.includes('create_live') ||
        permissions.includes('create-live')
      )
    },
    getDateWithZero(number) {
      if (number < 10) return `0${number}`
      return number
    },
    getStatus(status) {
      return this.statusLabels[status]
    },
    async setQualitiesPrices() {
      const hasText = (text, str) => !!~text.indexOf(str)

      const qualities = this.qualitiesToMakeAvailable
      const options = {
        style: 'currency',
        currency: this.currency,
      }

      const { data: livePrices } = await planApi.getPlans(
        this.userPlanInfo.currency
      )

      for (const addon of livePrices.addons) {
        for (const quality of qualities) {
          if (hasText(addon.name, quality)) {
            const amount = addon.prices[0].unit_amount / 100
            const localeAmount = amount.toLocaleString(
              this.currencyLocale,
              options
            )

            this.$set(this.prices, quality, localeAmount)
          }
        }
      }
    },
    handleCloseEvent() {
      this.newLiveDialog = false
    },
    handleReturnEvent() {
      this.modalKey += 1
      this.selectorKey += 3
      this.newLiveDialog = true
    },
    setCurrencyConfig() {
      const currency = this.userPlanInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    async readUserFolders() {
      try {
        let ret = await foldersApi.getUserFolders()
        let notDeletedFolders = ret.data.folders.filter(
          (folder) => folder.status != false
        )
        let deletedFolders = ret.data.folders.filter(
          (folder) => folder.status === false
        )
        this.UPDATE_MAIN_FOLDERS(notDeletedFolders)
        this.UPDATE_DELETED_FOLDERS(deletedFolders)
        this.UPDATE_ALL_FOLDERS(ret.data.folders)
      } catch (e) {
        console.log(e)
      }
    },
    getFolderPath(folder) {
      let theFolder = this.findFolderById(folder.folder_id)
      let folderArray = [theFolder]
      let searchMoreFolders = true

      do {
        let folder = folderArray[folderArray.length - 1]
        if (folder.parent_folder_id) {
          let parentFolderId = folder.parent_folder_id
          let parentFolder = this.findFolderById(parentFolderId)
          folderArray.push(parentFolder)
        } else {
          searchMoreFolders = false
        }
      } while (searchMoreFolders)

      folderArray = folderArray.map((folder) => folder.name)
      folderArray.push('')
      folderArray = folderArray.reverse()
      let folderPathString = folderArray.join('/')

      return folderPathString
    },
    handleOpenAddonsModal() {
      this.$emit('closeModal')
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.$router.push({ name: 'Cart' })
    },
    findFolderById(id) {
      return this.folders.find((folder) => {
        return folder.id === id
      })
    },
    async handleNewFolder() {
      this.fetchingNewFolder = true
      let folderObject = {
        name: this.newFolder.name.trim(),
      }
      if (this.lastFolder.id) {
        folderObject['parent_folder_id'] = this.lastFolder.id
      }
      try {
        let ret = await foldersApi.createFolder(folderObject)
        this.addFolder(ret.data)
        this.$root.$emit('addFolderVideosPage', ret.data)
      } catch (e) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `${e}`,
        })
      }
      this.fetchingNewFolder = false
      this.newFolderMenu = false
    },
    handleSelectFolder() {
      this.folder.folder_id = this.selectedFolder
        ? this.selectedFolder.id
        : this.lastFolder.id
      this.folder.folder_name = this.selectedFolder
        ? this.selectedFolder.name
        : this.lastFolder.name
      this.createLivePage = true
      this.choiceFolder = false
    },
    async handleAddLive() {
      if (this.userPlanInfo?.subscription?.status === 'trialing')
        return this.$root.$emit('modalWarningTrial')
      await this.loadData()
      this.handleSelectChange()
      this.selectedKey = this.form.selected
      this.totalSlotLivePlan =
        this.userPlanInfo.subscription?.metadata.total_parallel_live
      this.addonSlotLive = this.userPlanInfo.addons?.slot_live
        ? this.userPlanInfo.addons?.slot_live[0].quantity
        : 0
      let count = 0
      this.updateSelectedKey()
      this.allItems.forEach((live) => {
        live.status === 'online' || live.status === 'offline' ? count++ : ''
      })
      this.modalKey += 1
      this.selectorKey += 3
      this.newLiveDialog = true
      this.loadings.addLive = false
    },
    updateSelectedKey() {
      const defaultItem = this.list.keys.find((item) => item.default === true)
      if (defaultItem) {
        this.form.selected = defaultItem.id
        this.selectedKey = this.form.selected
      }
      if (defaultItem.is_attached) {
        const anotherItem = this.list.keys.find((item) => !item.is_attached)
        if (anotherItem === undefined) {
          this.isDisabled = true
          return
        }
        this.form.selected = anotherItem.id
        this.selectedKey = this.form.selected
        this.isDisabled = false
      }
    },
    handleNewLive() {
      this.$router.push({ name: 'NewLiveV2' })
    },
    openModal() {
      this.$root.$emit('openKeysModal')
    },
    closeModal() {
      this.isModalOpen = false
    },
    reducedBreadcrumbArray() {
      let arrayMod = this.breadcrumbArray.filter((folder) => {
        return folder.id !== this.lastFolder.id
      })
      if (this.selectedFolder) {
        return this.breadcrumbArray
      }
      return arrayMod
    },
    filterSelectedFolder() {
      if (this.$route.params.id) {
        return this.folders.filter(
          (folder) => folder.id != this.$route.params.id
        )
      } else {
        return this.folders
      }
    },
    selectAllItems() {
      if (this.selectedItems.length === this.allItems.length) {
        this.selectedItems = []
        return
      }
      this.selectedItems = [...this.allItems]
    },
    isNamesTooBig() {
      let size = 0
      for (let folder of this.breadcrumbArray) {
        size += folder.name.length
      }
      if (this.selectedFolder?.name) {
        size += this.selectedFolder.name.length
      }
      return size > 40
    },
    handleBackTo(backToFolder) {
      this.selectedFolder = null
      this.lastFolder = backToFolder
      if (!backToFolder.id) {
        this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
        return
      }
      if (
        this.breadcrumbArray.length < 2 ||
        this.breadcrumbArray[this.breadcrumbArray.length - 1].id ===
          backToFolder.id
      )
        return
      let index = this.breadcrumbArray.findIndex((folder) => {
        return folder.id === backToFolder.id
      })
      let newArr = this.breadcrumbArray.slice(0, index + 1)
      this.breadcrumbArray = newArr
    },
    lastBreadcrumbItem() {
      return this.breadcrumbArray[this.breadcrumbArray.length - 1]
    },
    handleEnterFolder(folder) {
      this.lastFolder = folder
      this.breadcrumbArray.push(folder)
    },
    handleRowClick(item) {
      let hasChildren = this.checkIfHasChildren(item)
      if (hasChildren) return this.handleEnterFolder(item)
    },
    checkIfHasChildren(folder) {
      let anySon = this.folders.find(
        (item) => item.parent_folder_id === folder.id
      )
      return anySon
    },
    handleClickRow(item) {
      this.goToPainel(item)
    },
    async handleRemoveLive(live) {
      if (this.selectedItems.length) {
        const liveArray = this.selectedItems.map((live) => ({
          live_id: live.id,
        }))
        this.$root.$emit('deleteVideoModal', liveArray, 'Live')
      } else {
        let array = []
        array.push(live)
        const liveArray = array.map((live) => ({ live_id: live.id }))
        this.$root.$emit('deleteVideoModal', liveArray, 'Live')
      }
    },
    checkIfSelected(item) {
      let foundItem = this.selectedItems.find((searchedItem) => {
        return searchedItem.id === item.id
      })
      if (foundItem) return true
      return false
    },
    checkboxSelection(item) {
      let alreadySelected = this.checkIfSelected(item)
      if (alreadySelected) {
        let newArr = [
          ...this.selectedItems.filter((lookFolder) => {
            return lookFolder.id !== item.id
          }),
        ]
        this.selectedItems = [...newArr]
      } else {
        this.selectedItems.push(item)
      }
    },
    show(item, e) {
      this.menuItem = item
      item.status === 'DRAFT'
        ? (this.disableVideoCopyLinks = true)
        : (this.disableVideoCopyLinks = false)
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    async createDefaultKey() {
      try {
        const { data } = await liveStreamKeyApi.createLiveStreamKey({
          title: this.$t('message.pages.live.default'),
        })
        this.list.keys.push(data)
        this.keysLength = this.list.keys.length
      } catch (err) {
        console.error('Erro ao criar chave padrão:', err)
      }
    },
    async loadKeysAttached() {
      if (this.list.keys.length > 1) {
        this.list.keys.filter((key) => {
          if (key.is_attached) this.keysAttached.push(key)
        })
      }
    },
    async loadKeysData() {
      try {
        const { data } = await liveStreamKeyApi.getAllLiveStreamKey()
        if (data.length === 0) {
          await this.createDefaultKey()
        } else {
          this.list.keys = data
          this.keysLength = this.list.keys.length
        }
        this.keyLoading = false
      } catch (err) {
        console.error('e', err)
      }
    },
    handleOrderByName() {
      if (!this.nameOrder || this.nameOrder === 'desc')
        return (this.nameOrder = 'asc')
      if (this.nameOrder === 'asc') return (this.nameOrder = 'desc')
    },
    orderByName() {
      if (this.nameOrder === 'asc') {
        this.allItems.sort((a, b) =>
          a.title.localeCompare(b.title, undefined, { numeric: true })
        )
      }
      if (this.nameOrder === 'desc') {
        this.allItems.sort(
          (a, b) =>
            -a.title.localeCompare(b.title, undefined, { numeric: true })
        )
      }
    },
    handleStatusPage() {
      let loc = this.locale
      if (loc === 'pt') return window.open(PANDA_STATUS_PAGE_BR, '_blank')
      return window.open(PANDA_STATUS_PAGE, '_blank')
    },
    handleClickAutocompleteRow(item) {
      if (!item) return
      this.goToPainel(item)
    },
    handleClickDatePickerOutside() {
      if (this.datePickerShow) this.datePickerShow = false
    },
    async fetchData() {
      try {
        let [page_num, lives_v2_list, live_list] = [1, [], []]
        this.isFetchingLives = true
        do {
          lives_v2_list = await liveService.getLives(page_num)
          let responseOldLive = await liveService.getOldLives()
          responseOldLive.data.forEach((live) => {
            live['old_live'] = true
            if (live.status === 'finished_imported' && live.video_id) {
              const videoInfo = lives_v2_list.data.find(
                (video) => video.id === live.video_id
              )
              if (videoInfo && videoInfo.status !== 'CONVERTED') {
                live.status = 'finished'
              }
            }
          })
          live_list.push(...lives_v2_list.data)
          live_list.push(...responseOldLive.data)
          if (page_num == 1 && !this.allItems.length) {
            this.allItems = [...lives_v2_list.data, ...responseOldLive.data]
            this.isLoading = false
          }
          page_num++
        } while (lives_v2_list.data.length == 100)
        this.isFetchingLives = false
        this.allItems = live_list
        Storage.setItem('lives', this.allItems)
      } catch (e) {
        this.showNoticeError = this.$t('message.pages.newLive.noticeError')
      }
    },
    filterHours() {
      this.datePickerShow = false
      const current_date = new Date()
      if (this.scheduleDate !== format(current_date, 'yyyy-MM-dd')) {
        this.hoursMinutes = this.allHoursMinutes
      } else {
        const current_hour = current_date.getHours()
        const current_minute = current_date.getMinutes()
        this.hoursMinutes = this.allHoursMinutes.filter((item) => {
          const [hour_string, minute_string] = item.split(':')
          const hour = parseInt(hour_string)
          const minute = parseInt(minute_string)
          if (current_hour > hour) return false
          if (current_hour === hour && current_minute >= minute) return false
          return true
        })
      }
    },
    handleClickSelect() {
      this.datePickerShow = true
      this.$refs.dateSelect.blur()
    },
    getAllowedDate(date_string) {
      const date = new Date(date_string)

      const date_next_month = addDays(new Date(), 31)

      const current_date = subDays(new Date(), 1)

      return isAfter(date, current_date) && isBefore(date, date_next_month)
    },
    handleOpenNewTab() {
      let routeData = {}
      routeData = this.$router.resolve({
        name: 'NewLiveV2',
        params: { id: this.menuItem.id },
      })
      window.open(routeData.href, '_blank')
    },
    handleCopyHLSEmbed(video) {
      let hls = video.live_hls
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.embedHlsCopiedToClipboard'),
      })
      navigator.clipboard.writeText(`${hls}`)
    },
    handleCopyCodeEmbed(video) {
      const code = video.live_id || video.id
      const open = true
      const text = i18n.t('message.embedCodeCopiedToClipboard')

      this.UPDATE_GLOBAL_SNACKBAR({ open, text })
      navigator.clipboard.writeText(`${code}`)
    },
    handleCopySrcEmbed(video) {
      const src = video.live_player
      const open = true
      const text = i18n.t('message.embedSrcCopiedToClipboard')

      this.UPDATE_GLOBAL_SNACKBAR({ open, text })
      navigator.clipboard.writeText(`${src}`)
    },
    handleCopyExternalIdEmbed(video) {
      const src = video.video_external_id
      const open = true
      const text = i18n.t('message.embedSrcCopiedToClipboard')
      this.UPDATE_GLOBAL_SNACKBAR({ open, text })
      navigator.clipboard.writeText(`${src}`)
    },
    handleShowLink(item) {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.copiedToClipboard'),
      })
      navigator.clipboard.writeText(`${item}`)
    },
    handleEmbedCopy() {
      if (this.srcEmbed) this.handleCopySrcEmbed(this.menuItem)
      else if (this.isExternalIdEmbed)
        this.handleCopyExternalIdEmbed(this.menuItem)
      else if (this.codeEmbed) this.handleCopyCodeEmbed(this.menuItem)
      else if (this.hlsEmbed) this.handleCopyHLSEmbed(this.menuItem)
      else this.handleShowLink(this.embed)
    },
    async fetchEmbedVideo() {
      this.fetching = true
      Storage.setItem('width', this.embedVideo.width)
      Storage.setItem('height', this.embedVideo.height)
      let storageEmbedOption = Storage.getItem('embedType')
      let embedOptionsValue = this.embedOptions.map((el) => el.value)
      let storageIndex = embedOptionsValue.indexOf(storageEmbedOption)

      if (storageIndex !== -1) {
        this.embedSelected = this.embedOptions[storageIndex].value
      } else {
        this.embedSelected = this.embedOptions[0].value
      }
      Storage.setItem('embedType', this.embedSelected)
      let pullzoneValue = Storage.getItem(
        `pullzone-${this.$store.state.user.userInfo.sub}`
      )
      this.userPullzoneName = pullzoneValue
      this.$root.$on(
        'changeEmbed',
        function () {
          this.embedSelected = Storage.getItem('embedType')
            ? Storage.getItem('embedType')
            : i18n.t('message.pages.videoEditModal.embedConfiguration.default')
        }.bind(this)
      )
      this.fetching = false
    },
    async openCustomizeEmbed(menuItem) {
      this.menuPosition = {
        link: {
          x: window.innerWidth / 2 - 300,
          y: 140,
        },
        embed: {
          x: window.innerWidth / 2 - 300,
          y: 140,
        },
        dots: {
          x: 1500,
          y: 140,
        },
      }

      this.video = menuItem
      this.videoId = menuItem.id

      const { video_id } = menuItem
      if (menuItem.status === 'finished_imported' && video_id) {
        const dbVideo = await window.db.videos.get(video_id)

        if (dbVideo && dbVideo.length) {
          const { length } = dbVideo
          this.video = {
            ...menuItem,
            length,
          }
          this.videoId = video_id
          this.timeVideo = length
        }
      }

      this.mustShowEmbedModal = false
      this.fetching = true
      this.showMenu = false
      this.showMenuEmbed = true
      setTimeout(
        function () {
          this.mustShowEmbedModal = true
        }.bind(this)
      )
      this.fetchEmbedVideo()
    },
    setEmbed(option, videoItem) {
      const optionDefault = i18n
        .t('message.pages.videoEditModal.embedConfiguration.default')
        .toLowerCase()

      option = option.toLowerCase()
      if (option === optionDefault) {
        option = this.embedSelected = 'general'
      }

      const [selectedOption] = this.embedOptions.filter(
        ({ value }) => value === option
      )

      const isExternalIdEmbed = ['123tapronto', 'tucano-members']
      const isSrcEmbed = [
        'cademi',
        'engaged',
        'ensinio',
        'monetizze',
        'membertizze',
        'ticto',
      ]
      const isCodeEmbed = ['entrega-digital', 'creators-land']
      const isHLSEmbed = ['xgrow', 'greatpages', 'minervaead']
      const isRadioActiveFalse = Object.keys(this.embedOptionOrientations)
      const isRadioActiveTrue = this.embedOptions
        .map(({ value }) => {
          if (
            ![...isHLSEmbed, ...isRadioActiveFalse, 'general'].includes(value)
          )
            return value
        })
        .filter(Boolean)

      this.video = {}
      this.fetching = true
      this.showMenu = false
      this.hlsEmbed = false
      this.codeEmbed = false
      this.srcEmbed = false
      this.embedSelected = option
      this.embedTrademark = selectedOption.text

      if (isExternalIdEmbed.includes(option)) {
        this.externalIdEmbed = true
        if (videoItem) this.handleCopyExternalIdEmbed(videoItem)
      } else if (isSrcEmbed.includes(option)) {
        this.srcEmbed = true
        if (videoItem) this.handleCopySrcEmbed(videoItem)
      } else if (isCodeEmbed.includes(option)) {
        this.codeEmbed = true
        if (videoItem) this.handleCopyCodeEmbed(videoItem)
      } else if (isHLSEmbed.includes(option)) {
        this.hlsEmbed = true
        this.radioActive = 1

        if (videoItem) this.handleCopyHLSEmbed(videoItem)
      } else {
        if (isRadioActiveTrue.includes(option)) {
          this.videoCustomSize = true
          this.radioActive = 1
        } else if (isRadioActiveFalse.includes(option)) {
          const orientation = this.isLandscapeOrientation
            ? 'landscape'
            : 'portrait'
          const { width, height } =
            this.embedOptionOrientations[option][orientation]

          this.videoCustomSize = false
          this.radioActive = 0

          this.embedVideo.width = width
          this.embedVideo.height = height
        }

        Storage.setItem('width', this.embedVideo.width)
        Storage.setItem('height', this.embedVideo.height)

        this.fetching = false
        this.video = videoItem

        if (this.embed) this.handleShowLink(this.embed)
      }

      Storage.setItem('embedType', option)
    },
    async getUserPullzoneName() {
      try {
        let ret = await referApi.getLibrary()
        this.userPullzoneName = ret.data.pullzone_name
        Storage.setItem(
          `pullzone-${this.$store.state.user.userInfo.sub}`,
          ret.data.pullzone_name
        )
      } catch (e) {
        setTimeout(() => {
          this.getUserPullzoneName
        }, 1000)
      }
    },

    async handleSelectedStreamKey(selectedKey) {
      this.stream_key_id = selectedKey
    },
    async handleCreateLive() {
      this.stream_key_id = this.handleSelectChange()

      if (this.stream_key_id === null)
        return alert('Please select a key before proceeding')

      this.loadings.createLive = true

      const bitrate =
        this.avalibleBitrates.length === 0 ? undefined : this.avalibleBitrates

      let dataCreate = {
        title: this.createLiveTitle,
        bitrate: bitrate,
        active_dvr: this.activeDvr,
        stream_key_id: this.stream_key_id,
        latency_type: this.latencySelect.selected,
      }
      if (this.folder.folder_id) {
        dataCreate['folder_id'] = this.folder.folder_id
      }

      if (this.selectedDateTime) {
        const date = this.selectedDateTime.toISOString()
        dataCreate.scheduled_at = date.replace('Z', '')
      }

      try {
        const response = await liveService.createLive(dataCreate, false)
        const live_cache = Storage.getItem('lives')
        if (live_cache) {
          Storage.setItem('lives', [response.data, ...live_cache])
        }

        this.$router.push({
          name: 'NewLiveV2',
          params: { id: response.data.id },
        })
        this.showNoticeError = null
      } catch (error) {
        this.showNoticeError = error.message.includes('400')
          ? this.$t('message.pages.newLive.noticeErrorKeyInUse')
          : this.$t('message.pages.newLive.noticeError')
        this.errors.createLive = true
      } finally {
        this.loadings.createLive = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/data-table';

.page-live {
  &::v-deep {
    .page-view__content {
      padding-bottom: 0;
    }
  }
}

::v-deep .scroller[data-v-55a76cbe] {
  height: 85%;
}

@media (max-height: 780px) {
  ::v-deep .scroller[data-v-55a76cbe] {
    height: 80%;
  }
}
</style>

<style lang="scss" scoped>
.status {
  &--scheduled {
    @media (max-width: 1440px) {
      font-size: 90%;
    }
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
.headerDataTable {
  font-size: 0.75rem !important;
  color: var(--v-neutral-lighten1);
}
.main-table {
  width: 100%;
}

.live-btn {
  width: 100%;
}

.main-container {
  height: 100%;
}

.v-dialog {
  border-radius: 8px;
  box-shadow: 0px 2px 20px 0px #00000026;
}

.createLive-title {
  color: var(--v-brand-darken2);
}

.createLive-icon {
  color: var(--v-brand-darken2);
}

.bg-dark {
  .modalItem-title {
    color: var(--v-primary-base);
  }
  .createLive-icon {
    color: white;
  }
  .createLive-title {
    color: white;
  }
  .v-input--selection-controls .v-input__slot > .v-label,
  .v-input--selection-controls .v-radio > .v-label {
    color: var(--v-neutral-lighten2);
  }
}
.modalItem-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  color: var(--v-neutral-lighten1);
}

.spanDescription {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--v-neutral-lighten1);
}

.gold-only-label {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--v-neutral-lighten1);
}

.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--v-neutral-base);
}

.custom-outlined {
  border: 1px solid var(--v-neutral-lighten2);
  padding: 4px 12px 4px 12px;
  border-radius: 4px;
}

.timeSelect {
  border: 1px solid var(--v-neutral-lighten2);
  border-radius: 4px;
  height: 40px;
  padding: 4px 12px 4px 12px;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  display: none;
}

.v-text-field > .v-input__control > .v-input__slot:after {
  display: none;
}

.datepicker-container {
  .datepicker-item {
    position: absolute;
    left: 10pxpx;
    z-index: 2000;
  }
}

.svgArrowUp {
  position: relative;
  bottom: 300px;
  right: 40px;
}

.circle {
  margin-right: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  display: inline-block;
}

.status-style {
  margin-top: 9px;
  color: red;
  font-weight: 400;
  background-color: transparent !important;
  padding: 0;
}

div.item-line:hover .hoveredClass {
  display: block !important;
}

div.item-line .hoveredClass {
  display: none !important;
}

.t-header {
  display: none;
}

.displayBlock {
  display: block;
}

.displayNone {
  display: none;
}

.pointerTable {
  cursor: pointer;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
}

.page-live .data-table__content .virtual-scroller::-webkit-scrollbar-thumb {
  background-color: #d0d1d9 !important;
}

.page-live .data-table__content .virtual-scroller::-webkit-scrollbar {
  width: 4px;
    border-radius: 8px;
}

.page-live .data-table__content.virtualTable .virtual-scroller::-webkit-scrollbar-thumb {
  background-color: #52577a !important;
}
</style>
